import { delay } from "lodash"
import { call, cancel, put, race, select, take, takeLatest } from "redux-saga/effects"
import { getExternalSourceFacilitiesRequest, getExternalSourceFacilitiesSuccess, getFacilityStatusSuccess, getInternalSourceFacilitiesRequest, getInternalSourceFacilitiesSuccess, GET_EXTERNAL_SOURCE_FACILITIES_FAILURE, GET_EXTERNAL_SOURCE_FACILITIES_REQUEST, GET_FACILITY_STATUS_REQUEST, GET_INTERNAL_SOURCE_FACILITIES_FAILURE, GET_INTERNAL_SOURCE_FACILITIES_REQUEST } from "../actions/facilityAction"
import { getCheckGroupFailure, getCheckGroupSuccess, GET_CHECK_GROUP_FAILURE, GET_CHECK_GROUP_REQUEST, patchAffiliatedGroupRequest } from "../actions/physicianAction"
import { getExternalSourceFacilitiesCall, getFacilityStatusApiCall, getInternalSourceFacilitiesCall, postCreateFacilityAPICall } from "../apis/facilityCallApi"
import { getSingleGroupAPICall, postCreateGroupAPICall } from "../apis/physicianCallApi"
import AuthService from "../services/AuthService"
import { checkAuthorizationError, clearNotification, dataLoadingNotification, errorNotification } from "../utils/notification-helpers"

function * getExternalFacilitiesHandler () {
  try {
    const auth = new AuthService()
    const { userSettings } = auth.getProfile() || {}
    const { affiliatedGroup } = userSettings || {}
    if (affiliatedGroup && affiliatedGroup !== "") {
      const { responseStatus, responseJSON } = yield call(getExternalSourceFacilitiesCall)
      if(responseStatus >= 200 && responseStatus < 300){
        const facilities = responseJSON && responseJSON.facilities
        yield put(getExternalSourceFacilitiesSuccess(facilities))
      }
      else if(responseStatus === 401){
        throw Error(responseStatus);
      }
    } else {
      yield put(getExternalSourceFacilitiesSuccess([])) 
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_EXTERNAL_SOURCE_FACILITIES_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getInternalFacilitiesHandler () {
  try {
    const { responseStatus, responseJSON } = yield call(getInternalSourceFacilitiesCall)
    if(responseStatus >= 200 && responseStatus < 300){
      const facilities = responseJSON && responseJSON.facilities
      yield put(getInternalSourceFacilitiesSuccess(facilities))
    }
    else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_INTERNAL_SOURCE_FACILITIES_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getFacilityStatusSaga () {
  try {
    while (true) {
      const { end } = yield race({
        poll: call(poll),
        end: take('POLL_END')
      });

      if (end) {
        yield cancel();
      }
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_FACILITY_STATUS_REQUEST,
      message: e.message
    })
  }
}


function* poll(studyGuid, studyStatus) {

  while (true) {
    try {
      let response = yield call(getFacilityStatusApiCall)

      const { responseStatus, responseJSON } = response

        if (responseStatus === 200) {
          yield put(getFacilityStatusSuccess(responseJSON))
        } else if(responseStatus === 401){
          throw Error(responseStatus);
        }


      yield call(delay, 30000);
    } catch (e) {
      yield put({ type: 'POLL_END' });
      checkAuthorizationError(e.message)
    }
  }
}


function* sourceFacilityHandler({ payload }) {
  try {
    const { sourceFacilityName, affiliatedGroupOfLoggedInUser, affiliated_group, facilityType, closeModal } = payload

    const internalSourceFacility = yield select((state) => state.internalSourceFacility);
    const externalSourceFacility = yield select((state) => state.externalSourceFacility)
    const { responseStatus, responseJSON } = yield call(getSingleGroupAPICall, sourceFacilityName)
    clearNotification()
    if (responseStatus >= 200 && responseStatus < 300) {
      if (responseJSON && responseJSON?.length > 0) {
        const findFacility = externalSourceFacility.find(item => item?.name === sourceFacilityName) || internalSourceFacility.find(item => item?.name === sourceFacilityName)
        if(findFacility){
          closeModal(findFacility.guid)
        } else {
          closeModal("true")
          
          errorNotification(('This Facility Already Exists.'))
        }
      } else {
        dataLoadingNotification('')
        const { responseStatus: createGroupResponseStatus, responseJSON: createGroupResponse } = yield call(postCreateGroupAPICall, { name: sourceFacilityName, affiliatedGroupOfLoggedInUser })
        clearNotification()
        if (createGroupResponseStatus >= 200 && createGroupResponseStatus < 300) {
          const { group_id: sourceGroupGuid } = createGroupResponse
          const { responseStatus: createFacilityStatus, responseJSON: createFacilityResponse } = yield call(postCreateFacilityAPICall, { sourceFacilityName, sourceGroupGuid: affiliated_group ? affiliatedGroupOfLoggedInUser : sourceGroupGuid, facilityType })
          if (createFacilityStatus >= 200 && createFacilityStatus < 300) {
            const { guid: sourceFacilityGuid } = createFacilityResponse
            yield put(patchAffiliatedGroupRequest({ affiliatedGroupGuid: affiliatedGroupOfLoggedInUser, sourceGroupGuid }))
            yield put(getCheckGroupSuccess());
            if (affiliated_group) {
              yield put(getInternalSourceFacilitiesRequest())
            } else {
              yield put(getExternalSourceFacilitiesRequest())
            }
            if (closeModal) closeModal(sourceFacilityGuid);
          } else if (responseStatus === 401) {
            yield put(getCheckGroupFailure());
            throw Error(responseStatus);
          }
        } else if (responseStatus === 401) {
          throw Error(responseStatus);
        }
      }
    }
    else if (responseStatus === 401) {
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_CHECK_GROUP_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


export function * facilitySaga () {
  yield takeLatest(GET_EXTERNAL_SOURCE_FACILITIES_REQUEST, getExternalFacilitiesHandler)
  yield takeLatest(GET_INTERNAL_SOURCE_FACILITIES_REQUEST, getInternalFacilitiesHandler)
  yield takeLatest(GET_FACILITY_STATUS_REQUEST, getFacilityStatusSaga)
  yield takeLatest(GET_CHECK_GROUP_REQUEST, sourceFacilityHandler)
}
